export var BarDirectionType;
(function (BarDirectionType) {
    BarDirectionType[BarDirectionType["DownToUp"] = 0] = "DownToUp";
    BarDirectionType[BarDirectionType["UpToDown"] = 1] = "UpToDown";
    BarDirectionType[BarDirectionType["LeftToRight"] = 2] = "LeftToRight";
    BarDirectionType[BarDirectionType["RightToLeft"] = 3] = "RightToLeft";
})(BarDirectionType || (BarDirectionType = {}));
